import React from 'react';
import { createPortal } from 'react-dom';
import { useTheme, jsx } from '@emotion/react';
import { IndeedThemeProvider } from '../IndeedThemeProvider/IndeedThemeProvider.js';
import '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import '@indeed/ifl-css';
import '@indeed/ifl-icons';
import '@indeed/ihl-use-id';
import '../IndeedThemeProvider/utils.js';
import '../IndeedThemeProvider/theme.js';
import 'deepmerge';
import '@indeed/ifl-themes';
import '../LinkProvider/LinkProvider.js';

const Portal = props => {
  const {
    children,
    /* eslint-disable no-undef */
    /**
     * Update our eslint config to accommodate newer globals. Currently only
     * allow for ES6.
     */
    container = globalThis?.document?.body,
    /**
     * Note: some components (like IPL `Modal`) may depend on the default
     * `wrapper`. Be cautious when changing.
     */
    wrapper = "ifl-portal"
  } = props;
  const {
    direction
  } = useTheme();
  const Content = wrapper ? (/*#__PURE__*/React.createElement(wrapper, {}, jsx(IndeedThemeProvider, {
    dir: direction,
    "data-ifl-portal": true
  }, children))) : jsx(IndeedThemeProvider, {
    dir: direction,
    "data-ifl-portal": true
  }, children);
  return container ? /*#__PURE__*/createPortal(Content, container) : null;
};
Portal.displayName = "Portal";

export { Portal };
